/**
 *  Filter Option Set
 */

import * as types from '../constants/ActionTypes'

const filtersReducerDefaultState = {
    category: [],
    size:[],
    color: [],
    ratings:"",
    value: { min: 150, max: 1050 },
    sortBy: ""
};
const filtersReducer = (state = filtersReducerDefaultState, action) => {
    switch (action.type) {
        case types.FILTER_CATEGORY:
            return {
                ...state,
                category: action.category
            };
        case types.FILTER_SIZE:
            return {
                ...state,
                sizes: action.size
            };
        case types.FILTER_COLOR:
            return {
                ...state,
                color: action.color
            };
        case types.FILTER_PRICE:
            return {
                ...state,
                value: {min: action.value.value.min, max: action.value.value.max }
            };
        case types.SORT_BY:
            return {
                ...state,
                sortBy: action.sort_by
            };
        case types.FILTER_RATING:
            return {
                ...state,
                ratings: action.rating
            };
        default:
            return state;
    }
}

export default filtersReducer;